import { deleteData, getData, postData, postFormData } from './config/ApiCalls';

import { apiSettings } from '../Settings';

export const saveBid = async (id, data) => {
  try {
    const response = await postFormData(
      `${apiSettings.bids.saveBid(id)}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getLastSubmittedBid = async (id) => {
  try {
    const response = await getData(
      `${apiSettings.bids.getLastSubmittedBid(id)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getLastDraftBid = async (id) => {
  try {
    const response = await getData(`${apiSettings.bids.getLastDraftBid(id)}`);
    return response;
  } catch (error) {
    return null;
  }
};

export const getDraftBids = async (page = 1, searchText = '') => {
  try {
    const response = await getData(
      `${apiSettings.bids.getDraftBids(page, searchText)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getSubmittedBids = async (page = 1, searchText = '') => {
  try {
    const response = await getData(
      `${apiSettings.bids.getSubmittedBids(page, searchText)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const changeBidStatus = async (id = '', status = '') => {
  try {
    const response = await getData(
      `${apiSettings.bids.changeBidStatus(id, status)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getAllBidsByTenderId = async (id = '') => {
  try {
    const response = await getData(
      `${apiSettings.bids.getAllBidsByTenderId(id)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};
